import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { paths } from 'client/shared/Paths';
import { ButtonPrimary } from '@spotify-internal/encore-web';

const NoTaxiDistributionErrorModal = ({
  onClickClose,
}: {
  onClickClose: () => void;
}) => {
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={onClickClose}
      aria-labelledby="no-taxi-distribution-error-modal-title"
    >
      <Modal.Title id="no-taxi-distribution-error-modal-title">
        This feature is unavailable
      </Modal.Title>
      <Modal.Body>To unlock this feature, contact support.</Modal.Body>
      <Modal.Footer>
        <ButtonPrimary
          href={`${paths.getHelpPage(
            'newRequest'
          )}?ticket_form_id=360000826772`}
          kind="link"
          target="_blank"
        >
          Contact Support
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};

export { NoTaxiDistributionErrorModal };
